import Vue from "vue";
import VueRouter from "vue-router";

// ============================== Start Views ==============================
// Home
import Home from "../views/Home.vue";

// ********** Children
import HomePage from "../views/children/HomePage.vue";

// ========== Start Profiles ==========

// ========== End Profiles ==========

// ============================== START:: CRUDS ==============================

// ========== Start:: Static Screens ==========
// import StaticScreens from "../views/children/StaticScreens/Home.vue";
// ========== End:: Static Screens ==========

// ========== Start:: Reference ==========
// import Reference from "../Reference/Reference.vue";
// ========== End:: Reference ==========

// ********** Auth
import Login from "../views/Auth/Login.vue";

// ********** NotFound
import NotFound from "../views/NotFound.vue";
// ============================== End Views ==============================

// Vuex store
import store from "../store/index";
let router = null;
window.rootRouter = router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // Main
    {
      path: "/",
      component: Home,
      children: [
        {
          path: "/",
          name: "HomePage",
          component: HomePage,
        },
        // ============================== Start CRUDS ==============================
        // ******* Start Countries *******
        {
          path: "/countries",
          component: () => import("../views/children/CRUDS/Countries/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCountries",
              component: () =>
                import("../views/children/CRUDS/Countries/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CountryShow",
              component: () =>
                import("../views/children/CRUDS/Countries/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CountryEdit",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CountryAdd",
              component: () =>
                import("../views/children/CRUDS/Countries/Form.vue"),
            },
          ],
        },
        {
          path: "/products",
          component: () => import("../views/children/CRUDS/Products/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllProducts",
              component: () =>
                import("../views/children/CRUDS/Products/ShowAll.vue"),
            },

            // Edit
            {
              path: "edit/:id",
              name: "ProductsEdit",
              component: () =>
                import("../views/children/CRUDS/Products/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ProductsAdd",
              component: () =>
                import("../views/children/CRUDS/Products/Form.vue"),
            },
          ],
        },
        {
          path: "/ports",
          component: () => import("../views/children/CRUDS/Ports/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPorts",
              component: () =>
                import("../views/children/CRUDS/Ports/ShowAll.vue"),
            },

            // Edit
            {
              path: "edit/:id",
              name: "PortsEdit",
              component: () =>
                import("../views/children/CRUDS/Ports/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PortsAdd",
              component: () =>
                import("../views/children/CRUDS/Ports/Form.vue"),
            },
          ],
        },
        {
          path: "/materials",
          component: () => import("../views/children/CRUDS/Materials/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "All’aterials",
              component: () =>
                import("../views/children/CRUDS/Materials/ShowAll.vue"),
            },

            // Edit
            {
              path: "edit/:id",
              name: "materialsEdit",
              component: () =>
                import("../views/children/CRUDS/Materials/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "MaterialsAdd",
              component: () =>
                import("../views/children/CRUDS/Materials/Form.vue"),
            },
          ],
        },
        // ******* End Countries *******
        // ******* Start Cities *******
        {
          path: "/cities",
          component: () => import("../views/children/CRUDS/Cities/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCities",
              component: () =>
                import("../views/children/CRUDS/Cities/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CityShow",
              component: () =>
                import("../views/children/CRUDS/Cities/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CityEdit",
              component: () =>
                import("../views/children/CRUDS/Cities/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CityAdd",
              component: () =>
                import("../views/children/CRUDS/Cities/Form.vue"),
            },
          ],
        },
        // ******* End Cities *******
        // ******* Start Videos *******
        {
          path: "/videos",
          component: () => import("../views/children/CRUDS/Videos/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllVideos",
              component: () =>
                import("../views/children/CRUDS/Videos/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "VideoShow",
              component: () =>
                import("../views/children/CRUDS/Videos/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "VideoEdit",
              component: () =>
                import("../views/children/CRUDS/Videos/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "VideoAdd",
              component: () =>
                import("../views/children/CRUDS/Videos/Form.vue"),
            },
          ],
        },
        // ******* End Videos *******
        // ******* Start testimonials *******
        {
          path: "/testimonials",
          component: () =>
            import("../views/children/CRUDS/Testimonials/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTestimonials",
              component: () =>
                import("../views/children/CRUDS/Testimonials/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "Testimonialsshow",
              component: () =>
                import("../views/children/CRUDS/Testimonials/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "TestimonialsEdit",
              component: () =>
                import("../views/children/CRUDS/Testimonials/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "TestimonialAdd",
              component: () =>
                import("../views/children/CRUDS/Testimonials/Form.vue"),
            },
          ],
        },
        {
          path: "/work",
          component: () =>
            import("../views/children/CRUDS/Work/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllWork",
              component: () =>
                import("../views/children/CRUDS/Work/ShowAll.vue"),
            },
       
            {
              path: "edit/:id",
              name: "WorkEdit",
              component: () =>
                import("../views/children/CRUDS/Work/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "WorkAdd",
              component: () =>
                import("../views/children/CRUDS/Work/Form.vue"),
            },
          ],
        },
        {
          path: "/rates",
          component: () => import("../views/children/CRUDS/Rates/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllRates",
              component: () =>
                import("@/views/children/CRUDS/Rates/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Testimonialsshow",
            //   component: () =>
            //     import("../views/children/CRUDS/Testimonials/Show.vue"),
            //   props: true,
            // },
          ],
        },
        // ******* End testimonials *******
        // ******* Start Privacy *******
        {
          path: "/privacy",
          component: () => import("../views/children/CRUDS/Privacy/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPrivacy",
              component: () =>
                import("../views/children/CRUDS/Privacy/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "CityShow",
            //   component: () =>
            //     import("../views/children/CRUDS/Privacy/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "PrivacyEdit",
              component: () =>
                import("../views/children/CRUDS/Privacy/Form.vue"),
              props: true,
            },
            // // Add
            {
              path: "add",
              name: "PrivacyAdd",
              component: () =>
                import("../views/children/CRUDS/Privacy/Form.vue"),
            },
          ],
        },
        {
          path: "/seo_settings",
          component: () => import("../views/children/CRUDS/Seo/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSeo",
              component: () =>
                import("../views/children/CRUDS/Seo/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "seoShow",
              component: () => import("../views/children/CRUDS/Seo/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "seoEdit",
              component: () => import("../views/children/CRUDS/Seo/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "seoAdd",
              component: () => import("../views/children/CRUDS/Seo/Form.vue"),
            },
          ],
        },
        {
          path: "/clients",
          component: () => import("../views/children/CRUDS/Clients/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllClients",
              component: () =>
                import("../views/children/CRUDS/Clients/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "CityShow",
            //   component: () =>
            //     import("../views/children/CRUDS/Privacy/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "ClientsEdit",
              component: () =>
                import("../views/children/CRUDS/Clients/Form.vue"),
              props: true,
            },
            // // Add
            {
              path: "add",
              name: "ClientsAdd",
              component: () =>
                import("../views/children/CRUDS/Clients/Form.vue"),
            },
          ],
        },
        {
          path: "/teams",
          component: () => import("../views/children/CRUDS/Teams/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTeams",
              component: () =>
                import("../views/children/CRUDS/Teams/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "CityShow",
            //   component: () =>
            //     import("../views/children/CRUDS/Privacy/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "TeamsEdit",
              component: () =>
                import("../views/children/CRUDS/Teams/Form.vue"),
              props: true,
            },
            // // Add
            {
              path: "add",
              name: "TeamsAdd",
              component: () =>
                import("../views/children/CRUDS/Teams/Form.vue"),
            },
          ],
        },
        {
          path: "/objectives",
          component: () => import("../views/children/CRUDS/Objectives/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllObjectives",
              component: () =>
                import("../views/children/CRUDS/Objectives/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "CityShow",
            //   component: () =>
            //     import("../views/children/CRUDS/Privacy/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "ObjectivesEdit",
              component: () =>
                import("../views/children/CRUDS/Objectives/Form.vue"),
              props: true,
            },
            // // Add
            {
              path: "add",
              name: "ObjectivesAdd",
              component: () =>
                import("../views/children/CRUDS/Objectives/Form.vue"),
            },
          ],
        },
        {
          path: "/tools",
          component: () => import("../views/children/CRUDS/Tools/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTools",
              component: () =>
                import("../views/children/CRUDS/Tools/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "CityShow",
            //   component: () =>
            //     import("../views/children/CRUDS/Privacy/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "ToolsEdit",
              component: () =>
                import("../views/children/CRUDS/Tools/Form.vue"),
              props: true,
            },
            // // Add
            {
              path: "add",
              name: "ToolsAdd",
              component: () =>
                import("../views/children/CRUDS/Tools/Form.vue"),
            },
          ],
        },
        // ******* End Privacy *******
        // ******* Start Terms *******
        {
          path: "/terms",
          component: () => import("../views/children/CRUDS/Terms/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllTerms",
              component: () =>
                import("../views/children/CRUDS/Terms/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "TermShow",
              component: () => import("../views/children/CRUDS/Terms/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "TermEdit",
              component: () => import("../views/children/CRUDS/Terms/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "TermAdd",
              component: () => import("../views/children/CRUDS/Terms/Form.vue"),
            },
          ],
        },
        {
          path: "/subscriptions",
          component: () => import("../views/children/CRUDS/Subscriptions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSubscriptions",
              component: () =>
                import("../views/children/CRUDS/Subscriptions/ShowAll.vue"),
            },
            // Show Single
          
        
          ],
        },
        // ******* End Terms *******

        // ******* Start Faqs *******
        // {
        //   path: "/faqs",
        //   component: () => import("../views/children/Settings/Faq/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "faqs",
        //       component: () =>
        //         import("../views/children/Settings/Faq/ShowAll.vue"),
        //     },
        //     // Show Single
        //     // {
        //     //   path: "show/:id",
        //     //   name: "faqsShow",
        //     //   component: () =>
        //     //     import("../views/children/Settings/Faq/Show.vue"),
        //     //   props: true,
        //     // },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "faqsEdit",
        //       component: () =>
        //         import("../views/children/Settings/Faq/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "faqsAdd",
        //       component: () =>
        //         import("../views/children/Settings/Faq/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End Faqs *******

        // ***** Contact Messages

        {
          path: "/contacts",
          component: () =>
            import("@/views/children/CRUDS/ContactMessages/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "ContactMessagesAll",
              component: () =>
                import("@/views/children/CRUDS/ContactMessages/ShowAll.vue"),
            },
            // Show
            {
              path: "show/:id",
              name: "ContactMessagesShow",
              component: () =>
                import("@/views/children/CRUDS/ContactMessages/Show.vue"),
              props: true,
            },
            // Edit
            // {
            //   path: "edit/:id",
            //   name: "useTermsEdit",
            //   component: () =>
            //     import("@/views/children/CRUDS/ContactMessages/Form.vue"),
            //   props: true,
            // },
            // // Add
            // {
            //   path: "add",
            //   name: "useTermsAdd",
            //   component: () =>
            //     import("@/views/children/CRUDS/ContactMessages/Form.vue"),
            // },
          ],
        },
        {
          path: "/recruitments",
          component: () =>
            import("../views/children/CRUDS/Recruitments/Home.vue"),
          children: [
            // Show Single
            {
              path: "show-all",
              name: "recruitmentsShow",
              component: () =>
                import("../views/children/CRUDS/Recruitments/ShowAll.vue"),
              props: true,
            },
            {
              path: "show/:id",
              name: "recruitmentShow",
              component: () =>
                import("../views/children/CRUDS/Recruitments/Show.vue"),
              props: true,
            },
          ],
        },
        {
          path: "/partnership_requests",
          component: () =>
            import("../views/children/CRUDS/PartnershipRequests/ShowAll.vue"),
          children: [
            // Show Single
            {
              path: "show-all",
              name: "partnershipRequestsShow",
              component: () =>
                import(
                  "../views/children/CRUDS/PartnershipRequests/ShowAll.vue"
                ),
              props: true,
            },
          ],
        },

        {
          path: "/appliers",
          component: () =>
            import("../views/children/CRUDS/Appliers/ShowAll.vue"),
          children: [
            // Show Single
            {
              path: "show-all",
              name: "appliersShow",
              component: () =>
                import("../views/children/CRUDS/Appliers/ShowAll.vue"),
              props: true,
            },
          ],
        },
        // Appointments
        {
          path: "/appointments",
          component: () =>
            import("../views/children/CRUDS/Appointments/ShowAll.vue"),
          children: [
            // Show Single
            {
              path: "show-all",
              name: "AppointmentShow",
              component: () =>
                import("../views/children/CRUDS/Appointments/Show.vue"),
              props: true,
            },
          ],
        },

        // ******* Start Users *******
        {
          path: "/users",
          component: () => import("../views/children/CRUDS/Users/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllUsers",
              component: () =>
                import("../views/children/CRUDS/Users/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "UserShow",
              component: () => import("../views/children/CRUDS/Users/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "UserEdit",
              component: () => import("../views/children/CRUDS/Users/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "UserAdd",
              component: () => import("../views/children/CRUDS/Users/Form.vue"),
            },
          ],
        },
        // ******* End Users *******
        // ******* Start Hedayat *******
        {
          path: "/hedayat",
          component: () => import("../views/children/CRUDS/Hedayat/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllHedayat",
              component: () =>
                import("../views/children/CRUDS/Hedayat/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "HedayatShow",
              component: () =>
                import("../views/children/CRUDS/Hedayat/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End Hedayat *******
        {
          path: "/comments",
          component: () => import("../views/children/CRUDS/Comments/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllComments",
              component: () =>
                import("../views/children/CRUDS/Comments/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CommentsShow",
              component: () =>
                import("../views/children/CRUDS/Comments/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End Hedayat *******
        // ******* Start Providers *******
        // {
        //   path: "/providers",
        //   component: () => import("../views/children/CRUDS/Providers/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllProviders",
        //       component: () =>
        //         import("../views/children/CRUDS/Providers/ShowAll.vue"),
        //     },
        //     // Show Single
        //     {
        //       path: "show/:id",
        //       name: "ProviderShow",
        //       component: () =>
        //         import("../views/children/CRUDS/Providers/Show.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "ProviderEdit",
        //       component: () =>
        //         import("../views/children/CRUDS/Providers/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "ProviderAdd",
        //       component: () =>
        //         import("../views/children/CRUDS/Providers/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End Providers *******
        // ******* Start Categories *******
        {
          path: "/categories",
          component: () => import("@/views/children/CRUDS/Categories/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCategories",
              component: () =>
                import("@/views/children/CRUDS/Categories/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "categoryShow",
              component: () =>
                import("@/views/children/CRUDS/Categories/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "categoryEdit",
              component: () =>
                import("@/views/children/CRUDS/Categories/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "categoryAdd",
              component: () =>
                import("@/views/children/CRUDS/Categories/Form.vue"),
            },
          ],
        },
        // ******* End Categories *******
        // ******* Start Faq *******
        {
          path: "/Faq",
          component: () => import("@/views/children/CRUDS/Faq/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllFaq",
              component: () => import("@/views/children/CRUDS/Faq/ShowAll.vue"),
            },

            // Edit
            {
              path: "edit/:id",
              name: "FaqEdit",
              component: () => import("@/views/children/CRUDS/Faq/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "FaqAdd",
              component: () => import("@/views/children/CRUDS/Faq/Form.vue"),
            },
          ],
        },
        // ******* End Faq *******
        // ******* Start Coupons *******
        {
          path: "/coupons",
          component: () => import("@/views/children/CRUDS/Coupons/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCoupons",
              component: () =>
                import("@/views/children/CRUDS/Coupons/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "CouponShow",
              component: () =>
                import("@/views/children/CRUDS/Coupons/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "CouponEdit",
              component: () =>
                import("@/views/children/CRUDS/Coupons/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CouponAdd",
              component: () =>
                import("@/views/children/CRUDS/Coupons/Form.vue"),
            },
          ],
        },
        // ******* End Coupons *******
        // ******* Start Patients *******
        {
          path: "/patients",
          component: () => import("@/views/children/CRUDS/Patients/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPatients",
              component: () =>
                import("@/views/children/CRUDS/Patients/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "patientShow",
              component: () =>
                import("@/views/children/CRUDS/Patients/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "PatientEdit",
              component: () =>
                import("@/views/children/CRUDS/Patients/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PatientAdd",
              component: () =>
                import("@/views/children/CRUDS/Patients/Form.vue"),
            },
          ],
        },
        // ******* End Patients *******
        // ******* Start branches *******
        {
          path: "/branches",
          component: () => import("@/views/children/CRUDS/Branches/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllBranches",
              component: () =>
                import("@/views/children/CRUDS/Branches/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "brancheShow",
              component: () =>
                import("@/views/children/CRUDS/Branches/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "brancheEdit",
              component: () =>
                import("@/views/children/CRUDS/Branches/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "brancheAdd",
              component: () =>
                import("@/views/children/CRUDS/Branches/Form.vue"),
            },
          ],
        },
        // ******* End branches *******
        // ******* Start Sliders *******
        {
          path: "/sliders",
          component: () => import("@/views/children/CRUDS/Sliders/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSliders",
              component: () =>
                import("@/views/children/CRUDS/Sliders/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "sliderEdit",
              component: () =>
                import("@/views/children/CRUDS/Sliders/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "sliderAdd",
              component: () =>
                import("@/views/children/CRUDS/Sliders/Form.vue"),
            },
          ],
        },
        {
          path: "/news",
          component: () => import("@/views/children/CRUDS/News/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllNews",
              component: () =>
                import("@/views/children/CRUDS/News/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "newsEdit",
              component: () => import("@/views/children/CRUDS/News/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "newsAdd",
              component: () => import("@/views/children/CRUDS/News/Form.vue"),
            },
          ],
        },
        // ******* End Sliders *******
        // Start Orgainzations provider
        {
          path: "/organizations",
          component: () =>
            import("@/views/children/CRUDS/Organizations/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOrganizations",
              component: () =>
                import("@/views/children/CRUDS/Organizations/ShowAll.vue"),
            },
            // Edit
            {
              path: "edit/:id",
              name: "OrganizationEdit",
              component: () =>
                import("@/views/children/CRUDS/Organizations/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "OrganizationAdd",
              component: () =>
                import("@/views/children/CRUDS/Organizations/Form.vue"),
            },
          ],
        },
        //Start providers videos
        {
          path: "/organizationsvideos",
          component: () =>
            import("@/views/children/CRUDS/OrganizationsVideos/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOrganizationsVideos",
              component: () =>
                import(
                  "@/views/children/CRUDS/OrganizationsVideos/ShowAll.vue"
                ),
            },
            // Edit
            {
              path: "edit/:id",
              name: "OrganizationVideosEdit",
              component: () =>
                import("@/views/children/CRUDS/OrganizationsVideos/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "OrganizationVideosAdd",
              component: () =>
                import("@/views/children/CRUDS/OrganizationsVideos/Form.vue"),
            },
          ],
        },
        {
          path: "/universities",
          component: () =>
            import("@/views/children/CRUDS/Universities/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllUniversities",
              component: () =>
                import("@/views/children/CRUDS/Universities/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Universitieshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Universities/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "universitiesEdit",
              component: () =>
                import("@/views/children/CRUDS/Universities/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "universitiesAdd",
              component: () =>
                import("@/views/children/CRUDS/Universities/Form.vue"),
            },
          ],
        },
        // ******* End Sliders *******
        // ******* Start Services *******
        {
          path: "/services",
          component: () => import("@/views/children/CRUDS/Services/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllServices",
              component: () =>
                import("@/views/children/CRUDS/Services/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "ServicesEdit",
              component: () =>
                import("@/views/children/CRUDS/Services/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ServicesAdd",
              component: () =>
                import("@/views/children/CRUDS/Services/Form.vue"),
            },
          ],
        },
        // ******* Start Services *******
        {
          path: "/specializations",
          component: () =>
            import("@/views/children/CRUDS/Specializations/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSpecializations",
              component: () =>
                import("@/views/children/CRUDS/Specializations/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "SpecializationsEdit",
              component: () =>
                import("@/views/children/CRUDS/Specializations/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "SpecializationsAdd",
              component: () =>
                import("@/views/children/CRUDS/Specializations/Form.vue"),
            },
          ],
        },

        {
          path: "/features",
          component: () => import("@/views/children/CRUDS/Features/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllFeatures",
              component: () =>
                import("@/views/children/CRUDS/Features/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "FeaturesEdit",
              component: () =>
                import("@/views/children/CRUDS/Features/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "FeaturesAdd",
              component: () =>
                import("@/views/children/CRUDS/Features/Form.vue"),
            },
          ],
        },
      
        {
          path: "/departments",
          component: () => import("@/views/children/CRUDS/Departments/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllDepartments",
              component: () =>
                import("@/views/children/CRUDS/Departments/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "DepartmentsEdit",
              component: () =>
                import("@/views/children/CRUDS/Departments/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "DepartmentsAdd",
              component: () =>
                import("@/views/children/CRUDS/Departments/Form.vue"),
            },
            {
              path: ":id/benefits",
              name: "Allbenefits",
              component: () =>
                import("@/views/children/CRUDS/Departments/Benefits/ShowAll.vue"),
              props: true,
            },
            {
              path: ":id/benefits/add",
              name: "benefitsAdd",
              component: () =>
                import("@/views/children/CRUDS/Departments/Benefits/Form.vue"),
              props: true,
            },
            {
              path: ":id/benefits/edit/:id",
              name: "benefitsedit",
              component: () =>
                import("@/views/children/CRUDS/Departments/Benefits/Form.vue"),
              props: true,
            },
            {
              path: ":id/subDepartments",
              name: "AllSubDepartments",
              component: () =>
                import("@/views/children/CRUDS/Departments/SubDepartments/ShowAll.vue"),
              props: true,
            },
            {
              path: ":id/subDepartments/add",
              name: "SubDepartmentsAdd",
              component: () =>
                import("@/views/children/CRUDS/Departments/SubDepartments/Form.vue"),
              props: true,
            },
            {
              path: ":id/subDepartments/edit/:id",
              name: "SubDepartmentsedit",
              component: () =>
                import("@/views/children/CRUDS/Departments/SubDepartments/Form.vue"),
              props: true,
            },
          ],
        },
        // {
        //   path: "/benefits",
        //   component: () => import("@/views/children/CRUDS/Benefits/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllBenefits",
        //       component: () =>
        //         import("@/views/children/CRUDS/Benefits/ShowAll.vue"),
        //     },
        //     // Show Single
        //     // {
        //     //   path: "show/:id",
        //     //   name: "Serviceshow",
        //     //   component: () =>
        //     //     import("@/views/children/CRUDS/Services/Show.vue"),
        //     //   props: true,
        //     // },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "BenefitsEdit",
        //       component: () =>
        //         import("@/views/children/CRUDS/Benefits/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "BenefitsAdd",
        //       component: () =>
        //         import("@/views/children/CRUDS/Benefits/Form.vue"),
        //     },
        //   ],
        // },
        {
          path: "/fields",
          component: () => import("@/views/children/CRUDS/Fields/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllFields",
              component: () =>
                import("@/views/children/CRUDS/Fields/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "FieldsEdit",
              component: () =>
                import("@/views/children/CRUDS/Fields/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "FieldsAdd",
              component: () =>
                import("@/views/children/CRUDS/Fields/Form.vue"),
            },
          ],
        },
        {
          path: "/overview",
          component: () => import("@/views/children/CRUDS/Overview/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOverview",
              component: () =>
                import("@/views/children/CRUDS/Overview/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "OverviewEdit",
              component: () =>
                import("@/views/children/CRUDS/Overview/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "OverviewAdd",
              component: () =>
                import("@/views/children/CRUDS/Overview/Form.vue"),
            },
          ],
        },
        {
          path: "/owner_word",
          component: () => import("@/views/children/CRUDS/Owner/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllOwner",
              component: () =>
                import("@/views/children/CRUDS/Owner/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "OwnerEdit",
              component: () =>
                import("@/views/children/CRUDS/Owner/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "OwnerAdd",
              component: () =>
                import("@/views/children/CRUDS/Owner/Form.vue"),
            },
          ],
        },
        {
          path: "/project_manager_word",
          component: () => import("@/views/children/CRUDS/ProjectManager/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllProjectManager",
              component: () =>
                import("@/views/children/CRUDS/ProjectManager/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "ProjectManagerEdit",
              component: () =>
                import("@/views/children/CRUDS/ProjectManager/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ProjectManagerAdd",
              component: () =>
                import("@/views/children/CRUDS/ProjectManager/Form.vue"),
            },
          ],
        },

        {
          path: "/educations",
          component: () => import("@/views/children/CRUDS/Educations/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllEducations",
              component: () =>
                import("@/views/children/CRUDS/Educations/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "EducationsEdit",
              component: () =>
                import("@/views/children/CRUDS/Educations/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "EducationsAdd",
              component: () =>
                import("@/views/children/CRUDS/Educations/Form.vue"),
            },
          ],
        },

        {
          path: "/nationalities",
          component: () =>
            import("@/views/children/CRUDS/Nationalities/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllNationalities",
              component: () =>
                import("@/views/children/CRUDS/Nationalities/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "NationalitiesEdit",
              component: () =>
                import("@/views/children/CRUDS/Nationalities/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "NationalitiesAdd",
              component: () =>
                import("@/views/children/CRUDS/Nationalities/Form.vue"),
            },
          ],
        },
        {
          path: "/keywords",
          component: () => import("@/views/children/CRUDS/Keywords/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllKeywords",
              component: () =>
                import("@/views/children/CRUDS/Keywords/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "KeywordsEdit",
              component: () =>
                import("@/views/children/CRUDS/Keywords/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "KeywordsAdd",
              component: () =>
                import("@/views/children/CRUDS/Keywords/Form.vue"),
            },
          ],
        },
        {
          path: "/withdrawals",
          component: () =>
            import("@/views/children/CRUDS/Withdrawals/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllWithdrawals",
              component: () =>
                import("@/views/children/CRUDS/Withdrawals/ShowAll.vue"),
            },
          ],
        },
        {
          path: "/types_of_care",
          component: () => import("@/views/children/CRUDS/CareTypes/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllCareTypes",
              component: () =>
                import("@/views/children/CRUDS/CareTypes/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "CareTypesEdit",
              component: () =>
                import("@/views/children/CRUDS/CareTypes/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "CareTypesAdd",
              component: () =>
                import("@/views/children/CRUDS/CareTypes/Form.vue"),
            },
          ],
        },

        {
          path: "/scientific_degrees",
          component: () =>
            import("@/views/children/CRUDS/ScientificDegrees/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllScientificDegrees",
              component: () =>
                import("@/views/children/CRUDS/ScientificDegrees/ShowAll.vue"),
            },
            {
              path: "edit/:id",
              name: "ScientificDegreesEdit",
              component: () =>
                import("@/views/children/CRUDS/ScientificDegrees/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ScientificDegreesAdd",
              component: () =>
                import("@/views/children/CRUDS/ScientificDegrees/Form.vue"),
            },
          ],
        },

        {
          path: "/languages",
          component: () => import("@/views/children/CRUDS/Languages/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllLanguages",
              component: () =>
                import("@/views/children/CRUDS/Languages/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Serviceshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Services/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "LanguagesEdit",
              component: () =>
                import("@/views/children/CRUDS/Languages/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "LanguagesAdd",
              component: () =>
                import("@/views/children/CRUDS/Languages/Form.vue"),
            },
          ],
        },

        // Start sub services
        // {
        //   path: "/services2",
        //   component: () => import("@/views/children/CRUDS/Services2/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllServices2",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services2/ShowAll.vue"),
        //     },
        //     // Show Single
        //     {
        //       path: "show/:id",
        //       name: "Serviceshow",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services2/Show.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "Services2Edit",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services2/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "Services2Add",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services2/Form.vue"),
        //     },
        //     // Add SubService
        //     {
        //       path: "addsubservice",
        //       name: "SubServiceAdd",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services2/SubServiceForm.vue"),
        //     },
        //     {
        //       path: "addsubservice/:id",
        //       name: "SubServiceEdit",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services2/SubServiceForm.vue"),
        //       props: true,
        //     },
        //   ],
        // },
        // ******* Start About *******
        {
          path: "/about",
          component: () => import("@/views/children/CRUDS/About/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAbout",
              component: () =>
                import("@/views/children/CRUDS/About/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Abouthow",
            //   component: () =>
            //     import("@/views/children/CRUDS/About/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "AboutEdit",
              component: () => import("@/views/children/CRUDS/About/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AboutAdd",
              component: () => import("@/views/children/CRUDS/About/Form.vue"),
            },
          ],
        },
        // ******* End About *******
        // ******* Start Consultations *******
        {
          path: "/consultations",
          component: () =>
            import("@/views/children/CRUDS/Consultations/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllConsultations",
              component: () =>
                import("@/views/children/CRUDS/Consultations/ShowAll.vue"),
            },
          ],
        },
        // ******* End Consultations *******
        // ******* Start About *******
        {
          path: "/pages",
          component: () => import("@/views/children/CRUDS/Pages/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPages",
              component: () =>
                import("@/views/children/CRUDS/Pages/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Pageshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Pages/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "PagesEdit",
              component: () => import("@/views/children/CRUDS/Pages/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "PagesAdd",
              component: () => import("@/views/children/CRUDS/Pages/Form.vue"),
            },
          ],
        },
        // ******* End Pages *******
        // ******* Start About *******
        {
          path: "/jobs",
          component: () => import("@/views/children/CRUDS/Jobs/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllJobs",
              component: () =>
                import("@/views/children/CRUDS/Jobs/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Jobshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Jobs/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "JobsEdit",
              component: () => import("@/views/children/CRUDS/Jobs/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "JobsAdd",
              component: () => import("@/views/children/CRUDS/Jobs/Form.vue"),
            },
          ],
        },
        {
          path: "/articles",
          component: () => import("@/views/children/CRUDS/Articles/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllArticles",
              component: () =>
                import("@/views/children/CRUDS/Articles/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Articleshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Articles/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "ArticlesEdit",
              component: () => import("@/views/children/CRUDS/Articles/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "ArticlesAdd",
              component: () => import("@/views/children/CRUDS/Articles/Form.vue"),
            },
          ],
        },
        // ******* End Jobs *******
        // ******* Start WhyChooseUs *******
        {
          path: "/why_choose_us",
          component: () =>
            import("@/views/children/CRUDS/WhyChooseUs/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllWhyChooseUs",
              component: () =>
                import("@/views/children/CRUDS/WhyChooseUs/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "WhyChooseUshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/WhyChooseUs/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "WhyChooseUsEdit",
              component: () =>
                import("@/views/children/CRUDS/WhyChooseUs/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "WhyChooseUsAdd",
              component: () =>
                import("@/views/children/CRUDS/WhyChooseUs/Form.vue"),
            },
          ],
        },
        // ******* End WhyChooseUs *******
        // ******* Start HowItWorks *******
        {
          path: "/how_it_works",
          component: () => import("@/views/children/CRUDS/HowItWorks/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllHowItWorks",
              component: () =>
                import("@/views/children/CRUDS/HowItWorks/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "HowItWorkshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/HowItWorks/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "HowItWorksEdit",
              component: () =>
                import("@/views/children/CRUDS/HowItWorks/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "HowItWorksAdd",
              component: () =>
                import("@/views/children/CRUDS/HowItWorks/Form.vue"),
            },
          ],
        },
        // ******* End HowItWorks *******
        // ******* Start Blogs *******
        {
          path: "/blogs",
          component: () => import("@/views/children/CRUDS/Blogs/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllBlogs",
              component: () =>
                import("@/views/children/CRUDS/Blogs/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "Blogshow",
            //   component: () =>
            //     import("@/views/children/CRUDS/Blogs/Show.vue"),
            //   props: true,
            // },
            // Edit
            {
              path: "edit/:id",
              name: "BlogsEdit",
              component: () => import("@/views/children/CRUDS/Blogs/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "BlogsAdd",
              component: () => import("@/views/children/CRUDS/Blogs/Form.vue"),
            },
          ],
        },
        // ******* Start Sliders *******
        // {
        //   path: "/service",
        //   component: () => import("@/views/children/CRUDS/Services/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllServices",
        //       component: () =>
        //         import("@/views/children/CRUDS/Services/ShowAll.vue"),
        //     },
        //   ],
        // },
        // ******* End Sliders *******
        // ******* Start Steps *******
        // {
        //   path: "/steps",
        //   component: () => import("@/views/children/CRUDS/Steps/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllSteps",
        //       component: () =>
        //         import("@/views/children/CRUDS/Steps/ShowAll.vue"),
        //     },
        //     // Show Single
        //     {
        //       path: "show/:id",
        //       name: "stepShow",
        //       component: () => import("@/views/children/CRUDS/Steps/Show.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "stepEdit",
        //       component: () => import("@/views/children/CRUDS/Steps/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "stepAdd",
        //       component: () => import("@/views/children/CRUDS/Steps/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End Steps *******
        // ******* Start Offers *******
        // {
        //   path: "/categories",
        //   component: () => import("@/views/children/CRUDS/Categories/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllCategories",
        //       component: () =>
        //         import("@/views/children/CRUDS/Categories/ShowAll.vue"),
        //     },
        //     // Show Single
        //     {
        //       path: "show/:id",
        //       name: "categoriesShow",
        //       component: () => import("@/views/children/CRUDS/Categories/Show.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "categoriesEdit",
        //       component: () => import("@/views/children/CRUDS/Categories/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "CategoriesAdd",
        //       component: () => import("@/views/children/CRUDS/Categories/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End Offers *******
        // ******* Start Sales *******
        // {
        //   path: "/subjects",
        //   component: () => import("@/views/children/CRUDS/Subjects/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllSubjects",
        //       component: () =>
        //         import("@/views/children/CRUDS/Subjects/ShowAll.vue"),
        //     },
        //     // Show Single
        //     {
        //       path: "show/:id",
        //       name: "subjectShow",
        //       component: () => import("@/views/children/CRUDS/Subjects/Show.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "subjectEdit",
        //       component: () => import("@/views/children/CRUDS/Subjects/Form.vue"),
        //       props: true,
        //     },
        //     // Add
        //     {
        //       path: "add",
        //       name: "subjectAdd",
        //       component: () => import("@/views/children/CRUDS/Subjects/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End Sales *******
        // ******* Start notifications *******
        {
          path: "/notifications",
          component: () =>
            import("@/views/children/CRUDS/notifications/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-notifications",
              component: () =>
                import("@/views/children/CRUDS/notifications/ShowAll.vue"),
            },
            // Show Single

            {
              path: "add",
              name: "add-notification",
              component: () =>
                import("@/views/children/CRUDS/notifications/Form.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "NotificationShow",
              component: () =>
                import("@/views/children/CRUDS/notifications/Show.vue"),
              props: true,
            },
          ],
        },
        // ******* End notifications *******
        // ******* Start Subscribers *******
        {
          path: "/subscribers",
          component: () =>
            import("@/views/children/CRUDS/Subscribers/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllSubscribers",
              component: () =>
                import("@/views/children/CRUDS/Subscribers/ShowAll.vue"),
            },
            // Show Single
            // {
            //   path: "show/:id",
            //   name: "SubscribersShow",
            //   component: () => import("@/views/children/CRUDS/Subscribers/Show.vue"),
            //   props: true,
            // },
          ],
        },
        // ******* End Subscribers *******
        // ******* Start Discounts *******
        // {
        //   path: "/discounts",
        //   component: () => import("@/views/children/CRUDS/Discounts/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "AllDiscounts",
        //       component: () =>
        //         import("@/views/children/CRUDS/Discounts/ShowAll.vue"),
        //     },
        //     // Show Single
        //     {
        //       path: "show/:id",
        //       name: "DiscountShow",
        //       component: () => import("@/views/children/CRUDS/Discounts/Show.vue"),
        //       props: true,
        //     },
        //   ],
        // },
        // ******* End Discounts *******
        // ******* Start  Admins *******
        {
          path: "/admins",
          component: () => import("@/views/children/CRUDS/Admins/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAdmins",
              component: () =>
                import("@/views/children/CRUDS/Admins/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "adminShow",
              component: () => import("@/views/children/CRUDS/Admins/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "adminEdit",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "adminAdd",
              component: () => import("@/views/children/CRUDS/Admins/Form.vue"),
            },
          ],
        },
        // ******* End  Admins *******
        // ******* Start  Doctors *******
        {
          path: "/doctors",
          component: () => import("@/views/children/CRUDS/Doctors/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllDoctors",
              component: () =>
                import("@/views/children/CRUDS/Doctors/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "Doctorshow",
              component: () =>
                import("@/views/children/CRUDS/Doctors/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "DoctorsEdit",
              component: () =>
                import("@/views/children/CRUDS/Doctors/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "DoctorsAdd",
              component: () =>
                import("@/views/children/CRUDS/Doctors/Form.vue"),
            },
          ],
        },
        // ******* End  Doctors *******
        // ******* Start New Doctors *******
        {
          path: "/new_doctors",
          component: () => import("@/views/children/CRUDS/NewDoctors/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllNewDoctors",
              component: () =>
                import("@/views/children/CRUDS/NewDoctors/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "NewDoctorshow",
              component: () =>
                import("@/views/children/CRUDS/NewDoctors/Show.vue"),
              props: true,
            },
            {
              path: "edit/:id",
              name: "NewDoctorEdit",
              component: () =>
                import("@/views/children/CRUDS/NewDoctors/Form.vue"),
              props: true,
            },
          ],
        },
        // ******* End  New Doctors *******
        // ******* Start Doctors Updates *******
        {
          path: "/doctors_updates",
          component: () =>
            import("@/views/children/CRUDS/DoctorsUpdates/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllDoctorsUpdates",
              component: () =>
                import("@/views/children/CRUDS/DoctorsUpdates/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "DoctorsUpdateshow",
              component: () =>
                import("@/views/children/CRUDS/DoctorsUpdates/Show.vue"),
              props: true,
            },
            {
              path: "edit/:id",
              name: "DoctorsUpdatesEdit",
              component: () =>
                import("@/views/children/CRUDS/DoctorsUpdates/Form.vue"),
              props: true,
            },
          ],
        },
        // ******* End   Doctors Updates *******
        // ******* Start  Authors *******
        {
          path: "/authors",
          component: () => import("@/views/children/CRUDS/Authors/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllAuthors",
              component: () =>
                import("@/views/children/CRUDS/Authors/ShowAll.vue"),
            },
            // Show Single
            {
              path: "show/:id",
              name: "Authorsshow",
              component: () =>
                import("@/views/children/CRUDS/Authors/Show.vue"),
              props: true,
            },
            // Edit
            {
              path: "edit/:id",
              name: "AuthorsEdit",
              component: () =>
                import("@/views/children/CRUDS/Authors/Form.vue"),
              props: true,
            },
            // Add
            {
              path: "add",
              name: "AuthorsAdd",
              component: () =>
                import("@/views/children/CRUDS/Authors/Form.vue"),
            },
          ],
        },
        // ******* End  Authors *******
        // ******* Start  Permission *******
        {
          path: "/permissions",
          component: () =>
            import("@/views/children/CRUDS/Permissions/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "AllPermissions",
              component: () =>
                import("@/views/children/CRUDS/Permissions/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "EditPermission",
              component: () =>
                import("@/views/children/CRUDS/Permissions/Form.vue"),
              props: true,
            },
            // Edit
            // {
            //   path: "add",
            //   name: "AddPermission",
            //   component: () =>
            //     import("@/views/children/CRUDS/Permissions/Form.vue"),
            // },
          ],
        },
        // ******* End  Permission *******
        // ******* Start  permissions-labels *******
        // {
        //   path: "/permission-labels",
        //   component: () =>
        //     import("@/views/children/CRUDS/PermissionLabels/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "all-permission-labels",
        //       component: () =>
        //         import("@/views/children/CRUDS/PermissionLabels/ShowAll.vue"),
        //     },
        //     // Show Single

        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "edit-permission-label",
        //       component: () =>
        //         import("@/views/children/CRUDS/PermissionLabels/Form.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "add",
        //       name: "add-permission-label",
        //       component: () =>
        //         import("@/views/children/CRUDS/PermissionLabels/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End  roles *******
        // ******* Start  roles *******
        {
          path: "/roles",
          component: () => import("@/views/children/CRUDS/Roles/Home.vue"),
          children: [
            // Show All
            {
              path: "show-all",
              name: "all-roles",
              component: () =>
                import("@/views/children/CRUDS/Roles/ShowAll.vue"),
            },
            // Show Single

            // Edit
            {
              path: "edit/:id",
              name: "edit-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
              props: true,
            },
            // Edit
            {
              path: "add",
              name: "add-role",
              component: () => import("@/views/children/CRUDS/Roles/Form.vue"),
            },
          ],
        },
        // ******* End  permissions-categories *******
        // ******* Start  permissions-categories *******
        // {
        //   path: "/permission-categories",
        //   component: () =>
        //     import("@/views/children/CRUDS/PermissionCategory/Home.vue"),
        //   children: [
        //     // Show All
        //     {
        //       path: "show-all",
        //       name: "all-permission-category",
        //       component: () =>
        //         import("@/views/children/CRUDS/PermissionCategory/ShowAll.vue"),
        //     },
        //     // Show Single

        //     // Edit
        //     {
        //       path: "edit/:id",
        //       name: "edit-permission-category",
        //       component: () =>
        //         import("@/views/children/CRUDS/PermissionCategory/Form.vue"),
        //       props: true,
        //     },
        //     // Edit
        //     {
        //       path: "add",
        //       name: "add-permission-category",
        //       component: () =>
        //         import("@/views/children/CRUDS/PermissionCategory/Form.vue"),
        //     },
        //   ],
        // },
        // ******* End  permissions-categories *******

        // ******* Start Live  Chat*******
        {
          path: "/chats/:id?",
          component: () => import("@/views/children/Chat/Index.vue"),
          name: "chats",
          props: true,
        },
        // ******* End  Live  Chat *******

        // ============================== End CRUDS ==============================

        // ========== Start StaticScreens ==========
        // {
        //   path: "/static-screens",
        //   name: StaticScreens,
        //   component: StaticScreens,
        // },
        // ========== End StaticScreens ==========

        // ========== Start Settings ==========
        {
          path: "/settings",
          component: () => import("../views/children/Settings/Home.vue"),
          children: [
            {
              path: "",
              name: "mainSettings",
              component: () => import("../views/children/Settings/General.vue"),
            },
            {
              path: "facts",
              name: "factsAdd",
              component: () => import("../views/children/Settings/Facts.vue"),
            },
            {
              path: "social",
              name: "socialSettings",
              component: () => import("../views/children/Settings/Social.vue"),
            },
            {
              path: "about-us",
              name: "aboutUs",
              component: () => import("../views/children/Settings/About.vue"),
            },
            // {
            //   path: "sms",
            //   name: "sms",
            //   component: () =>
            //     import("../views/children/Settings/SmsServices.vue"),
            // },
            // {
            //   path: "order-setting",
            //   name: "order-setting",
            //   component: () => import("../views/children/Settings/Orders.vue"),
            // },
            // {
            //   path: "app-links",
            //   name: "app-links",
            //   component: () =>
            //     import("../views/children/Settings/AppLinks.vue"),
            // },
          ],
        },
        // ========== End Settings ==========

        // ========== Start Profiles ==========
        {
          path: "/profile",

          component: () => import("@/views/children/adminProfile/Home.vue"),
          children: [
            {
              path: "show",
              name: "showProfile",
              component: () => import("@/views/children/adminProfile/Show.vue"),
            },
            {
              path: "edit",
              name: "editProfile",
              component: () => import("@/views/children/adminProfile/Form.vue"),
            },
            {
              path: "password",
              name: "changePassword",
              component: () =>
                import("@/views/children/adminProfile/ChangePassword.vue"),
            },
          ],
        },
        // ========== End Profiles ==========

        // ========== Start Reference==========
        // {
        //   path: "/reference",
        //   name: "Reference",
        //   component: Reference,
        // },
        // ========== End Reference ==========

        // ========== Start Chat ==========
        {
          path: "/financial_reports",
          name: "FinancialReports",
          component: () => import("@/views/children/FinancialReports/Home.vue"),
        },
        // ========== Start Chat ==========

        // ========== End Chat ==========

        // ========== Start DriversTracking ==========
        // {
        //   path: '/drivers_tracking',
        //   name: 'DriversTracking',
        //   component: DriversTracking,
        // },
        // ========== End DriversTracking ==========
      ],
    },

    {
      path: "/permission-required",
      name: "permission-required",
      component: () => import("../views/PermissionRequired.vue"),
    },

    //  =========== Start Redirects ===============
    {
      path: "/countries",

      redirect: () => {
        return { path: "/countries/show-all" };
      },
    },
    {
      path: "/about",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    {
      path: "/about/add",

      redirect: () => {
        return { path: "/about/show-all" };
      },
    },
    {
      path: "/terms/add",

      redirect: () => {
        return { path: "/terms/show-all" };
      },
    },
    {
      path: "/privacy/add",

      redirect: () => {
        return { path: "/privacy/show-all" };
      },
    },
    //  =========== End  Redirects ===============
    // Auth
    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    // NotFound
    { path: "/:notFound(.*)", name: "NotFound", component: NotFound },
  ],
});

const TOKEN = store.getters["auth_module/currentUser"].token;

router.beforeEach((to, _2, next) => {
  if (to.name !== "Login" && !TOKEN) {
    next({ name: "Login" });
  } else if (to.name == "Login" && TOKEN) {
    next("/");
  } else {
    next();
  }
});

Vue.use(VueRouter);
export default router;
